export default "__VITE_ASSET__DAXqfh7$__"